<!--
    Where a finished product is on its way to site: unknown, in rack, delivered,
    mounted. Named delivery, not logistics — logistics in this app is the
    material coming in, this is the product going out.

    The four values are a progression, so the colour warms up along it and
    `unknown` stays neutral: on most screens it is simply "not shipped yet",
    not a problem.
-->
<template>
    <v-chip :color="chip_color" :variant="variant" size="x-small">
        <v-icon v-if="icon" start size="12">{{ icon }}</v-icon>
        {{ t(`delivery_status_${status}`) }}
    </v-chip>
</template>

<script setup>
import { computed } from "vue";
import { usePitStoreBasics } from "@/stores/app_common";

const { t } = usePitStoreBasics();

const props = defineProps({
    // Either a constructible, or the raw status string.
    constructible: { type: Object, default: null },
    modelValue: { type: String, default: "" },
    variant: { type: String, default: "tonal" },
});

const status = computed(
    () => props.constructible?.delivery_status || props.modelValue || "unknown");

const chip_color = computed(() => ({
    in_rack: "info",
    delivered: "success",
    mounted: "primary",
}[status.value] || ""));

const icon = computed(() => ({
    in_rack: "mdi-bookshelf",
    delivered: "mdi-map-marker-check",
    mounted: "mdi-home-check",
}[status.value] || ""));
</script>
